module.exports = __webpack_public_path__ + "img/img3.cab97edc.png";